import Navbar from "./modules/Navbar"
import Sponsors from "./modules/Sponsors";
import ItemSlider from "./modules/ItemsSlider";
import Modal from "./modules/Modal";
import Carousel from "./modules/Carousel";
import Slider from "./modules/Slider";
import Forms from "./modules/Forms";
import LoadMoreResults from "./modules/LoadMoreResults";
import FormRecherche from "./modules/FormRecherche";
import TogglePassword from "./modules/TogglePassword";

const navbar = new Navbar();
const sponsors = new Sponsors();
const itemslider = new ItemSlider();
const modal = new Modal();
const carousel = new Carousel();
const slider = new Slider();
const form = new Forms();
const loadmoreresults = new LoadMoreResults();
const formrecherche = new FormRecherche();
const togglepassword = new TogglePassword();